import React from 'react';
import PropTypes from 'prop-types';
import { CHAT_MESSAGE_TYPE, SESSION_TYPES } from '@medflex/utils/constants';
import SessionMeetingMessage from './SessionMeetingMessage';
import SessionCallMessage from './SessionCallMessage';

const SessionMessage = ({ type, ...props }) => {
  switch (type) {
    case CHAT_MESSAGE_TYPE.SESSION_MEETING:
      return <SessionMeetingMessage type={SESSION_TYPES.MEETING} {...props} />;
    case 'session__call':
    case CHAT_MESSAGE_TYPE.SESSION_CALL:
      return <SessionCallMessage {...props} />;
    default:
      return <div>unknown type</div>;
  }
};

SessionMessage.propTypes = {
  type: PropTypes.oneOf([CHAT_MESSAGE_TYPE.SESSION_CALL, CHAT_MESSAGE_TYPE.SESSION_MEETING]),
};

export default SessionMessage;
